module.exports = __webpack_public_path__ + "static/media/RP_Cumberlandmetro.f2bed105.jpg";